import { generateTTS } from '../services/api.js';
import { tr } from '../services/i18n.js';
import { get, put, has } from '../services/cache.js';
import { TTS_ENABLED } from '../utils/constants.js';

export async function renderTTSPlayer(container, text) {
  // Garde-fou : si la synthèse vocale est désactivée, on ne rend aucun lecteur
  // et on n'appelle jamais /api/tts, quel que soit l'appelant.
  if (!TTS_ENABLED) return;
  const hash = await textHash(text);
  const cached = await has(hash);

  const wrapper = document.createElement('div');
  wrapper.className = 'glass-card';
  wrapper.innerHTML = `
    <p style="font-weight:600;margin-bottom:12px;">🔊 ${tr("Écouter l'analyse", 'Listen to the analysis')}</p>
    <div class="tts-player">
      <button id="tts-btn" class="btn-ghost" style="width:44px;height:44px;border-radius:50%;padding:0;display:flex;align-items:center;justify-content:center;font-size:18px;">
        ▶️
      </button>
      <div class="tts-waveform" id="tts-waveform"></div>
    </div>
    <p id="tts-note" style="display:none;margin-top:10px;font-size:13px;color:var(--text-muted, #5f6f68);"></p>
    <audio id="tts-audio" style="display:none;"></audio>
  `;
  container.appendChild(wrapper);

  const btn = wrapper.querySelector('#tts-btn');
  const audio = wrapper.querySelector('#tts-audio');
  const waveform = wrapper.querySelector('#tts-waveform');
  const note = wrapper.querySelector('#tts-note');

  let isPlaying = false;

  function showNote(message) {
    if (!message) {
      note.style.display = 'none';
      note.textContent = '';
      return;
    }
    note.textContent = message;
    note.style.display = 'block';
  }

  // Generate bars
  for (let i = 0; i < 20; i++) {
    const bar = document.createElement('div');
    bar.className = 'tts-bar';
    bar.style.height = (4 + Math.random() * 20) + 'px';
    bar.style.animationDelay = (i * 0.05) + 's';
    bar.style.animationPlayState = 'paused';
    waveform.appendChild(bar);
  }

  if (cached) {
    const blob = await get(hash);
    audio.src = URL.createObjectURL(blob);
  }

  btn.addEventListener('click', async () => {
    if (isPlaying) {
      audio.pause();
      setPlaying(false);
      return;
    }

    if (!audio.src) {
      btn.textContent = '⏳';
      try {
        if (await has(hash)) {
          const blob = await get(hash);
          audio.src = URL.createObjectURL(blob);
          showNote('');
        } else {
          const result = await generateTTS(text);
          if (result.type === 'audio') {
            await put(hash, result.blob);
            audio.src = URL.createObjectURL(result.blob);
            showNote('');
          } else {
            // Voix indisponible (quota atteint ou MiniMax KO) : message clair
            // renvoyé par l'API. Aucune voix navigateur de secours.
            btn.textContent = '▶️';
            showNote(result.error || tr('Voix momentanément indisponible. Réessaie plus tard.', 'Voice temporarily unavailable. Try again later.'));
            return;
          }
        }
      } catch (e) {
        btn.textContent = '▶️';
        showNote(tr('Lecture audio indisponible pour le moment. Réessaie plus tard.', 'Audio playback unavailable for now. Try again later.'));
        return;
      }
    }

    audio.play();
    setPlaying(true);
    audio.onended = () => setPlaying(false);
  });

  function setPlaying(state) {
    isPlaying = state;
    btn.textContent = state ? '⏸️' : '▶️';
    waveform.querySelectorAll('.tts-bar').forEach(b => {
      b.style.animationPlayState = state ? 'running' : 'paused';
    });
  }
}

async function textHash(str) {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
}
